<template>
    <div class="font-display flex min-h-screen flex-col items-center justify-between">
        <PublicHeaderSection />
        <div class="flex w-full grow flex-col">
            <slot />
        </div>
        <ClientOnly>
            <LazyPublicCookiePreferences hydrate-on-idle />
            <LazyPublicCookieConsent hydrate-on-idle />
        </ClientOnly>
        <PublicFooterSection />
    </div>
</template>
